// extracted by mini-css-extract-plugin
export default {"switch-input":"switch_switch-input__2iBdT"};